import { ReactElement } from 'react';
import { MRT_RowData } from 'mantine-react-table';
import { HubTable, HubTableProps } from '@/components/Hub/HubTable';
import { getCiQueueRowProps, PacQueueRowLike } from './listRowStyle';

/**
 * The Intake hub's table: the shared `HubTable` with a row that opens its
 * patient. Rows are two-line because the patient cell is.
 */

/** The first three columns are the same width on every tab; Status too where present. */
export const QUEUE_COLUMN_SIZE = { patient: 168, paymentTrack: 150, pn: 58, status: 80 } as const;

/** Notes' minimum width. It is the only column that grows. */
export const NOTES_MIN_SIZE = 200;

export interface QueueTableProps<Row extends MRT_RowData & PacQueueRowLike>
  extends Omit<HubTableProps<Row>, 'getRowProps'> {
  onOpenPatient: (patientId: string) => void;
}

export function QueueTable<Row extends MRT_RowData & PacQueueRowLike>({
  onOpenPatient,
  ...props
}: QueueTableProps<Row>): ReactElement {
  return <HubTable {...props} getRowProps={(original) => getCiQueueRowProps(original, onOpenPatient, {})} />;
}
